<template>
  <tr>
    <td>{{ filename }}</td>
    <td
      align="right"
      style="min-width:200px"
    >
      <div v-if="checksumming||uploading">
        <v-progress-linear
          height="24"
          :color="progressBarColor"
          :value="progress"
        >
          <strong>{{ progressBarText }}&nbsp;{{ Math.ceil(progress) }}%</strong>
        </v-progress-linear>
      </div>
      <div v-else-if="done">
        Uploaded successfully
      </div>
      <div v-else-if="(error != null)">
        {{ error }}
      </div>
      <div v-else>
        {{ fileSize(filesize) }}
      </div>
    </td>
    <td>
      <v-icon
        color="red"
        :disabled="showIcons"
        @click="$emit('removeItem', keyid)"
      >
        mdi-close-circle
      </v-icon>
    </td>
  </tr>
</template>

<script>
import { filesize } from "filesize";

export default {
  name: "UploadFileLine",
  props: {
    keyid: { type: String, default: '' },
    filename: { type: String, default: '' },
    filesize: { type: Number, default: 0 },
    uploading: {
      type: Boolean,
      default: false,
    },
    checksumming: {
      type: Boolean,
      default: false,
    },
    progress: {
      type: Number,
      default: 0,
    },
    done: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Error,
      default: null,
    }
  },
  emits: ['removeItem'],
  data: () => {
    return {
    }
  },
  computed: {
    progressBarColor() {
      return this.checksumming ? "yellow darken-2" : "blue darken-2"
    },
    progressBarText() {
      return this.checksumming ? "Calculating checksum" : "Uploading"
    },
    showIcons() {
      return (this.checksumming||this.uploading||this.done)
    }
  },
  methods: {
    fileSize(size) {
      return filesize(size)
    },
  },
}
</script>

<style>

</style>
